import './App.scss';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { Staff } from './components/staff/app/Staff';
import HomePage from './components/homepage/HomePage';
import { Calc } from './components/calculator/app/Сalc';
import { Currency } from './components/currency/Currency';

function App() {
  let pathname = useLocation().pathname;
  return (
      <>
        <header className='App'>
          <Link className={`${pathname === '/' && 'active'}`} to="/">Home</Link>
          <Link className={`${pathname === '/staff' && 'active'}`} to="/staff">Staff</Link>
          <Link className={`${pathname === '/calculator' && 'active'}`} to="/calculator">Calculator</Link>
          <Link className={`${pathname === '/currency' && 'active'}`} to="/currency">Currency</Link>
        </header>
        <Routes>
          <Route path='/staff' element={<Staff />} />
          <Route path='/calculator' element={<Calc/>} />
          <Route path='/currency' element={<Currency/>} />
          <Route path='*' element={<HomePage/>} />
        </Routes>
      </>
  )
}
  
export default App;
